module.exports = __webpack_public_path__ + "img/cases-brand-yanghe-lazyload-23.1a3054f5.jpg";